<template>
  <router-link :to="to" :class="buttonClasses" :disabled="disabled">
    <slot />
  </router-link>
</template>

<script>
export default {
  name: "NavigationButton",

  props: {
    to: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    buttonClasses() {
      return {
        button: true,
        disabled: this.disabled
      };
    }
  }
};
</script>

<style scoped lang="scss">
$background-color: #fafafa;
$hover-color: #eee;

.button {
  color: #000;
  text-decoration: none;
  background-color: $background-color;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.2s linear;
  cursor: pointer;

  &:hover {
    background-color: $hover-color;
  }

  &.disabled {
    cursor: default;
    opacity: 0.5;
    pointer-events: none;

    &:hover {
      background-color: $background-color;
    }
  }
}
</style>
